/**
 * Enhances route configurations by ensuring each route has a `level` property.
 * - If a route already has assigned roles, it retains them.
 * - If no roles are assigned, it sets the provided `level` parameter.
 *
 * @param {string | string[]} level - The default role(s) to be assigned if missing.
 * @param {Array<{ path: string; Component: any; level?: string[] }>} routes - The list of route objects.
 * @returns {Array<{ path: string; Component: any; level: string[] }>} - The updated routes with enforced roles.
 */
export function addLevelToRoutes(
  level: string | string[],
  routes: { path: string; Component: any; level?: string[] }[]
) {
  // Normalize level to an array if it's a string
  const normalizedLevel = Array.isArray(level) ? level : [level];

  return routes.map(route => ({
      ...route,
      level: route.level && route.level.length > 0 ? route.level : normalizedLevel, // Preserve existing roles if present
  }));
}
